import { Button, Dialog } from '@mui/material';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const DIALOG_CLASSES = { paper: 'deal-changed-dialog-paper' };
const DESCRIPTION_ID = 'deal-changed-dialog-description';

function DealChangedDialog({ modalIsOpen, onSeeCurrentPrices, onExited, roomName }) {
    const { t } = useTranslation();

    return (
        <Dialog
            className="deal-changed-dialog-main"
            classes={DIALOG_CLASSES}
            open={modalIsOpen}
            aria-describedby={DESCRIPTION_ID}
            TransitionProps={{ onExited }}
        >
            <div className="deal-changed-container" data-testid="deal-changed-dialog">
                <div className="deal-changed-text">
                    <h3 className="deal-changed-title">{t('DealChangedDialog.Title')}</h3>

                    {roomName ? <div className="deal-changed-room-name">{roomName}</div> : null}

                    <p className="deal-changed-message" id={DESCRIPTION_ID}>
                        {t('DealChangedDialog.Body')}
                    </p>
                </div>

                <div className="deal-changed-actions">
                    <Button
                        className="deal-changed-btn-confirm"
                        data-testid="deal-changed-see-current-prices"
                        variant="contained"
                        disableElevation
                        onClick={onSeeCurrentPrices}
                    >
                        {t('DealChangedDialog.SeeCurrentPrices')}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
}

DealChangedDialog.propTypes = {
    modalIsOpen: PropTypes.bool.isRequired,
    onSeeCurrentPrices: PropTypes.func.isRequired,
    onExited: PropTypes.func,
    roomName: PropTypes.string,
};

export default memo(DealChangedDialog);
